import { Outlet } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { styled, useTheme } from "@mui/material";
import Header from "./Header";

const Main = styled("main")(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  marginTop: theme.mixins.toolbar.minHeight,
  minHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
  backgroundColor: theme.palette.background.default,
}));

const AdminLayout = () => {
  const theme = useTheme();

  return (
    <Box sx={{ bgcolor: theme.palette.background.default }} id="admin-layout">
      {/* header */}
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: theme.palette.background.default,
          borderBottom: `2px solid ${theme.palette.divider}`,
          boxShadow:
            theme.palette.mode === "dark"
              ? "0px 4px 20px rgba(0, 0, 0, 0.3)"
              : "0px 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Toolbar>
          <Header />
        </Toolbar>
      </AppBar>

      {/* main content */}
      <Main>
        <Outlet />
      </Main>
    </Box>
  );
};

export default AdminLayout;
